import { tokenName } from '~/stores/tokenName';
import { userLogin } from '~/stores/userLogin'
import { useHeaderCurrentIndex } from '~/stores/header/headerCurrentIndex'
const currentIndexStore = useHeaderCurrentIndex()
export default defineNuxtRouteMiddleware((to, from) => {

   //创建路由守卫，检测是否登录
   const loginStore = userLogin().getLogin;
   const userRole = userLogin().getUserRole;
   console.log('当前的登录状态是 = ', loginStore)
   const route = useRoute();
   // if( to.path === '/personalCenter' || to.path === '/sourceDownload') {
   //    if(!loginStore){
   //       ElMessage({
   //          message:'请先登录',
   //          type:"warning"
   //       })
   //       return  abortNavigation()
   //    }   
   // }
   const token = useCookie(tokenName);
   if (token.value) {
      if (to.path === '/showcaseJudge' && userRole == 0) {
         ElMessage({
            message: '权限不够',
            type: "warning"
         })
         currentIndexStore.updateCurrentIndex(0)
         return navigateTo(`/`)
      }
   } else {
      if (!loginStore) {
         initCookie();
         ElMessage({
            message: '请先登录',
            type: "warning"
         })
         currentIndexStore.updateCurrentIndex(0)
         return navigateTo(`/`)
      }
   }
})
